import React from 'react'

type Props = {
  children: React.ReactNode
  className?: string
}

const ListCard: React.FC<Props> = React.memo(({ children, className = '' }) => (
  <div
    className={`d-flex align-items-center p-m white-bkg border-1 grey-20-border border-radius-5 ${className}`}
  >
    {children}
  </div>
))

ListCard.displayName = 'ListCard'

export default ListCard
